module.exports = __webpack_public_path__ + "img/photo.4788048f.png";